import { Component, OnInit } from '@angular/core';
import { FileReaderEvent } from '../../GET_NEW_UI/setup-implement/setup-implement.component';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-add-additional-attachment-get',
  templateUrl: './add-additional-attachment-get.component.html',
  styleUrls: ['./add-additional-attachment-get.component.scss']
})
export class AddAdditionalAttachmentGETComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<AddAdditionalAttachmentGETComponent>) { }
  NewFileNameGET: string = "";
  FilePreviewGET: string = "";
  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close({data:this.FilePreviewGET});
  }
  DialogClose_(){
    this.dialogRef.close();
  }
  onFileChangedGET(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.NewFileNameGET = event.target.files[0].name
      // reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
      //   var fileUrl = (event.target.result);
      //   this.FilePreviewGET = fileUrl;
      // }
      reader.onload = (event) => { // called once readAsDataURL is completed
        this.FilePreviewGET = (<FileReader>event.target).result.toString();
      }
    }
  }
}
